import { withInstall } from '@element-plus/utils/with-install'
import Row from './src/row'

export const ElRow = withInstall(Row)
export default ElRow

export * from './src/row'
